import { useState, useEffect, useContext } from "react";
import undrawProfile from "../img/undraw_profile.svg";
import { AppContext } from "../contexts/AppContext";
import { AuthContext } from "../contexts/AuthContext";
import axiosHttp from "../config/axios.interceptor";
import { errorResponseMessage } from "../shared/const.prop";
import PostList from "../shared/PostList";
import { getActiveNotificationCount } from "../store/actions/notificationAction";
import { useDispatch } from "react-redux";
import { getActiveChatNotificationCount } from "../store/actions/chatNotificationAction";
import { Link } from "react-router-dom";

const Bookmark = () => {
  const appContext = useContext(AppContext);
  const { user, logout } = useContext(AuthContext);
  const [postList, setPostList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  // const [count, setCount] = useState(10);
  const [isOpenArray, setIsOpenArray] = useState();
  const [initialLoad, setInitialLoad] = useState(false);
  const dispatch = useDispatch();
  const userId = user?.userId || user?.data?.data?.userId;
  const userName = user?.userName || user?.data?.data?.userName;

  // useEffect(() => {
  //   if (appContext.openModal === false) {
  //     fetchPosts(user);
  //   }
  // }, [page, count, user, appContext.openModal]);

  useEffect(() => {
    if (appContext.openModal === false) {
      setLoading(true);
      fetchPosts(1);
      setInitialLoad(true);
    } else {
      fetchPosts(page);
      setInitialLoad(true);
    }
  }, [appContext.openModal]);

  useEffect(() => {
    let debounceTimeout;

    const handleScroll = () => {
      clearTimeout(debounceTimeout);

      debounceTimeout = setTimeout(() => {
        const scrollY = window.scrollY;
        const viewportHeight = window.innerHeight;
        const pageHeight = document.documentElement.scrollHeight;

        const scrollThreshold = 0.8;

        const distanceFromBottom = pageHeight - (scrollY + viewportHeight);

        if (
          distanceFromBottom / pageHeight <= 1 - scrollThreshold &&
          !loading &&
          initialLoad
        ) {
          fetchPosts(page);
        }
      }, 200);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [page, loading, initialLoad]);

  useEffect(() => {
    dispatch(getActiveNotificationCount());
    dispatch(getActiveChatNotificationCount());
  }, []);

  const fetchPosts = async (page, isDelete = false) => {
    try {
      const getPostsList = await axiosHttp.get(
        `post-bookmarks?page=${page}&type=post`
      );
      if (getPostsList.status === 200) {
        let data = getPostsList?.data?.data;
        if (page === 1) {
          setPostList(data);
        } else {
          setPostList([...postList, ...data]);
        }
        if (isDelete) {
          setPage(2);
        } else {
          setPage(page + 1);
        }
        setIsOpenArray(data.map(() => false));
        setLoading(false);
      }
      // }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        logout();
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      if (e.response.status === 422 && page === 1) {
        setPostList([]);
      }
      if (e.response.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setLoading(false);
      setInitialLoad(false);
    }
  };

  const likePostHandler = async (id) => {
    try {
      const likePostResponse = await axiosHttp.post(`post/${id}/like`);
      if (likePostResponse.status === 201) {
        const updatedPostList = postList.map((post) => {
          if (post.id === id) {
            return {
              ...post,
              likeStatus: post.likeStatus === "Like" ? "DisLike" : "Like",
              postLikeCount:
                post.likeStatus === "Like"
                  ? post.postLikeCount - 1
                  : post.postLikeCount + 1,
            };
          }
          return post;
        });

        setPostList(updatedPostList);
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
    //console.log(error);
  };

  const bookHandler = async (id) => {
    try {
      const bookPostResponse = await axiosHttp.post(`post/${id}/bookmark`);
      if (bookPostResponse.status === 201) {
        fetchPosts(1);
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  const toggleDiv = (index) => {
    const newIsOpenArray = [...isOpenArray];
    newIsOpenArray[index] = !newIsOpenArray[index];
    setIsOpenArray(newIsOpenArray);
  };

  const editHandler = (post) => {
    const { type } = post;
    if (type === "image") {
      appContext.updateModalType("postPhoto", "Edit your photo", post);
    } else if (type === "doc") {
      appContext.updateModalType("postDocument", "Edit Document", post);
    } else if (type === "video") {
      appContext.updateModalType("postVideo", "Edit your video", post);
    } else if (type === "reels") {
      appContext.updateModalType("addReels", "Edit Reels", post);
    } else {
      appContext.updateModalType("postText", "Edit Text", post);
    }
  };

  const deleteHandler = async (post) => {
    try {
      const deletePost = await axiosHttp.delete(`post-data/${post.id}`);
      if (deletePost.status === 200) {
        setLoading(true);
        let isDelete = true;
        setPostList([]);
        fetchPosts(1, isDelete);
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        logout();
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      if (e.response.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setLoading(false);
    }
  };

  return (
    <>
      <p class="title">
        <Link to={`../${userName}`} class="arrow mr-3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M16.6667 10.2285C16.6667 10.5449 16.4316 10.8064 16.1266 10.8478L16.0417 10.8535L5.05508 10.853L9.02424 14.8059C9.26884 15.0495 9.26969 15.4452 9.02614 15.6898C8.80473 15.9122 8.45755 15.9331 8.21249 15.7521L8.14226 15.6917L3.10059 10.6717C3.06835 10.6396 3.04035 10.6049 3.01658 10.5682C3.00986 10.5571 3.00303 10.5458 2.99655 10.5343C2.99059 10.5244 2.98521 10.5142 2.98013 10.5038C2.97307 10.4887 2.96618 10.4731 2.95992 10.4572C2.95483 10.445 2.95059 10.433 2.94671 10.421C2.94211 10.4061 2.93764 10.3902 2.93379 10.3741C2.93093 10.3628 2.92866 10.352 2.92668 10.3411C2.9239 10.3249 2.92154 10.3081 2.91985 10.2912C2.91839 10.2782 2.91752 10.2654 2.91703 10.2526C2.91691 10.2448 2.91675 10.2367 2.91675 10.2285L2.91706 10.2043C2.91754 10.192 2.91838 10.1798 2.91958 10.1675L2.91675 10.2285C2.91675 10.1891 2.9204 10.1505 2.92739 10.1131C2.92901 10.1041 2.93094 10.095 2.93308 10.0858C2.93752 10.067 2.94265 10.0489 2.94855 10.0311C2.95146 10.0223 2.95483 10.0129 2.95844 10.0035C2.96575 9.98471 2.97369 9.96678 2.98242 9.94932C2.98648 9.94111 2.99102 9.93251 2.99578 9.924C3.00359 9.91012 3.01163 9.89693 3.02014 9.88407C3.02614 9.87497 3.03279 9.8655 3.03973 9.85617L3.04514 9.84897C3.06198 9.82697 3.08025 9.80612 3.09981 9.78657L3.10056 9.78599L8.14222 4.76515C8.3868 4.52158 8.78253 4.5224 9.0261 4.76698C9.24753 4.98933 9.26699 5.33659 9.08493 5.58089L9.02427 5.65086L5.05675 9.60301L16.0417 9.60351C16.3869 9.60351 16.6667 9.88333 16.6667 10.2285Z"
              fill="black"
              fill-opacity="0.6"
            />
          </svg>
        </Link>
        Bookmarks
      </p>
      <PostList
        loading={loading}
        postList={postList}
        likePostHandler={likePostHandler}
        // isEdit={true}
        expertiesKey="name"
        toggleDiv={toggleDiv}
        isOpenArray={isOpenArray}
        editHandler={editHandler}
        deleteHandler={deleteHandler}
        bookHandler={bookHandler}
      />
    </>
  );
};

export default Bookmark;
